// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-featured-clips-modal.modal2 {
   background-color: rgba(0, 0, 0, 0.9);
}

.home-featured-clips-modal .modal2__container {
    width: 90%;
    height: 90%;
    box-shadow: none;
}

.home-featured-clips-modal .modal2__header {
    background: transparent;
    color: var(--white-color);
    border-bottom: none;
}

.home-featured-clips-modal .modal2__header__title.baloa-subtitle-2 {
    color: var(--white-color) !important;
    font-size: 30px;
    font-weight: 700;
}

.home-featured-clips-modal .modal2__header__close_icon {
    color: var(--white-color);
    padding: 5px;
    background: var(--primary-dark-color);
    border-radius: 50%;
    font-size: 40px;
}

.home-featured-clips-modal .modal2__content {
    background: transparent;
    padding-top: 60px;
}

.home-featured-clips-modal__container{
    display: flex;
    align-items: flex-start;
    gap: 10px;
}

.home-featured-clips-modal__container .home-featured-clips-modal__media-container{
    width: 50%;
}

.home-featured-clips-modal__post-caption {
    padding: 12px 24px;
}

.home-featured-clips-modal__post-caption.baloa-names {
    color: var(--primary-very-dark-color);
    font-weight: var(--font-regular);
}

.home-featured-clips-modal__media-container {
    border-radius: 12px;
    background: var(--black-color);
    height: 90vh;
    display: flex;
    justify-content: center;
    align-items: center;
}

.home-featured-clips-modal__media-container .post-profile_video_clip_post{
    aspect-ratio: unset;
    text-align: center;
    max-height: 100%;
    max-width: 100%;
}

.home-featured-clips-modal__media-container .post-profile_video_clip_post .post-profile__video_clip{
    max-width: 100vw;
    max-height: 90vh;
}

.home-featured-clips-modal__media-container .post-profile_video_clip_post .post-profile_video_clip_video-control{
    height: 90%;
}

.home-featured-clips-modal__comments{
    width: 40%;
    background: var(--white-color);
    border-radius: 12px;
    height: 90vh;
}

.home-featured-clips-modal__comments .post_video_clips_actions__action{
    margin-right: unset;
    cursor: pointer;
}

.home-featured-clips-modal__comments .post__caption {
    max-height: calc(90vh - 254px);
    padding-bottom: 20px;
}

.home-featured-clips-modal__comments .post__caption.reacted {
    max-height: calc(90vh - 312px);
}

.profile_post_new-comment__photo{
    margin-right: var(--space-half);
    padding: var(--space-quarter);
}

.profile_post_new-comment__photo img{
    width: var(--space-x2-and-half);
    height: var(--space-x2-and-half);
    border-radius: 50%;
}


.profile-post-video-clip-modal__tournament-match-info{
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.profile-post-video-clip-modal__tournament_info{
    display: flex;
    align-items: center;
    background: var(--new-background-color);
    padding: 2px 4px;
    border-radius: 2px;
}

.profile-post-video-clip-modal__tournament_info .baloa-table{
    color: var(--primary-very-dark-color);
}

.profile-post-video-clip-modal__tournament_info__img{
    margin-right: 4px;
}

.profile-post-video-clip-modal__tournament_info__img img {
    width: 16px;
    height: 16px;
    border-radius: 50%;        
}

.profile-post-video-clip-modal__tournament_info__img .icon-ball {
    color: var(--white-color );
    font-size: 12px;
    border-radius: 50%;
    padding: 2px;    
}

.home-featured-clips-modal__slide-button {
    height: 100%;
    display: flex;
    align-items: center;
    width: 5%;
}

.home-featured-clips-modal__slide-button .hubicon-arrow_circle_right{
    font-size: 50px;
    font-weight: var(--font-bold);
    margin-left: auto;
}

.home-featured-clips-modal__slide-button .hubicon-arrow_circle_right .path1::before{
    color: var(--primary-dark-color);
}
.home-featured-clips-modal__slide-button .hubicon-arrow_circle_left{
    font-size: 50px;
    font-weight: var(--font-bold);
}

.home-featured-clips-modal__slide-button .hubicon-arrow_circle_left .path1::before{
    color: var(--primary-dark-color);
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    .home-featured-clips-modal .modal2__container{
        width: 100%;
        height: 100%;
        margin: 0;
        border-radius: 0;
        box-shadow: 0px 1px 4px rgba(150, 150, 150, 0.25);
        max-height: 100%;
    }

    .home-featured-clips-modal .modal2__header__title {
        display: none;
    }

    .home-featured-clips-modal .modal2__header__close {
        margin-left: auto;
    }

    .home-featured-clips-modal .modal2__header__close_icon {
        font-size: 24px;
        background: none;
    }

    .home-featured-clips-modal .modal2__content{
        height: 100%;
        padding: 0;
        display: inline;
    }

    .home-featured-clips-modal__container{
        display: block;
        height: 100%;
    }

    .home-featured-clips-modal__slide-button {
        width: 50px;
        height: 50px;
        z-index: 15;
    }

    .home-featured-clips-modal__slide-button.left {
        position: absolute;
        top: 50%;
    }

    .home-featured-clips-modal__slide-button .hubicon-arrow_circle_left {
        font-size: 24px;
        margin-left: 9px;
    }
    .home-featured-clips-modal__slide-button.right {
        position: absolute;
        top: 50%;
        right: 0;
    }

    .home-featured-clips-modal__slide-button .hubicon-arrow_circle_right {
        font-size: 24px;
        margin-right: 9px;
    }

    .home-featured-clips-modal__container .home-featured-clips-modal__media-container{
        width: 100%;
        /* background-color: var(--primary-very-dark-color); */
        border-radius: 0;
        margin: 0;
        height: 100%;
    }

    .home-featured-clips-modal__media-container .post-profile_video_clip_post {
        width: auto;
        height: auto;
    }

    .home-featured-clips-modal__media-container .post-profile_video_clip_post .post-profile__video_clip {
        max-width: 100vw;
        max-height: 100vh;
    }

    .home-featured-clips-modal__post-info {
        position: absolute;
        bottom: 70px;
        left: 14px;
    }

    .home-featured-clips-modal__post-info__author {
        display: flex;
        align-items: center;
    }

    .home-featured-clips-modal__post-info__author-photo {
        width: 35px;
        height: 35px;
        margin-right: 8px;
    }

    .home-featured-clips-modal__post-info__author-photo img{
        width: 35px;
        height: 35px;
        border-radius: 50%;
    }

    .home-featured-clips-modal__post-info__author-photo .icon-ball{
        font-size: 25px;
        padding: 5px;
        border-radius: 50%;
        color: var(--white-color);
    }

    .home-featured-clips-modal__post-info__author-name .iconb2-Verificated,
    .home-featured-clips-modal__post-info__author-name .iconbal-Balores {
        margin-left: 6px;
    }

    .home-featured-clips-modal__post-info__author-name.baloa-table {
        color: var(--white-color);
        font-weight: var(--font-medium);
    }

    .home-featured-clips-modal__post-info__author-username.baloa-username {
        color: var(--white-color);
        margin-top: 4px;
    }

    .home-featured-clips-modal__post-info__caption.baloa-table {
        color: var(--white-color);
        margin-top: 12px;
    }

    .home-featured-clips-modal__post-actions {
        position: absolute;
        bottom: 70px;
        right: 14px;
    }

    .home-featured-clips-modal__post-action {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 26px;
    }

    .home-featured-clips-modal__post-action .icon-claps-48 {
        color: var(--white-color);
        font-size: 22px;
    }

    .home-featured-clips-modal__post-action__text.baloa-mini{
        color: var(--white-color);
        margin-top: 5px;
        text-align: center;
    }

    .home-featured-clips-modal__post-action .icon-message {
        color: var(--white-color);
        font-size: 22px;
    }

    .home-featured-clips-modal__post-action .icon-share {
        color: var(--white-color);
        font-size: 22px;
    }

    .home-featured-clips-modal__post-action__option {
        box-shadow: 2px 2px 5px 2px #4444;
        padding: 0;
        /* width: 15%; */
        margin-top: -50px;
        list-style: none;
        position: absolute;
        right: 0;
    }

    .home-featured-clips-modal__post-action__option .post__actions__action__list__button span{
        text-wrap: nowrap;
    }

    .home-featured-clips-modal__post-action.icon-options {
        font-size: 22px;
        color: var(--white-color);
        transform: rotate(90deg);
    }

    .home-featured-clips-modal__menu-reactions .MuiList-root.MuiMenu-list {
        display: flex;
        align-items: center;
    }

    .MuiPopover-root.home-featured-clips-modal__menu-reactions .MuiPaper-rounded {
        border-radius: 44px;
        padding: 0 4px;
    }

    .home-featured-clips-modal__menu-reactions .MuiButtonBase-root.MuiMenuItem-root {
        padding: 0 4px;
    }

    .home-featured-clips-modal__menu-reactions .post__actions__action__menu-reactions__icon:hover {
        font-size: calc(var(--space-x3) + var(--space-half));
    }

    .home-featured-clips-modal__menu-reactions .post__actions__action__menu-reactions__icon {
        font-size: var(--space-x3);
        border-radius: 50%;
    }    
    
    .home-featured-clips-modal__post-actions .post__actions__action__reactions__icon {
        font-size: 22px;
    }

    .post__actions__action__reaction-green .baloa-mini {
        color: var(--new-green-color);
        margin-bottom: 26px;
    }

    .post__actions__action__reaction-yellow .baloa-mini {
        color: #EECA35;
        margin-bottom: 26px;
    }

    .post__actions__action__reaction-red .baloa-mini {
        color: #EB3B3B;
        margin-bottom: 26px;
    }
    /* .post__actions__action__menu-reactions__icon.iconr-clap {
        background: #70af99;
        border-radius: 50%;
        padding: 2px;
    }

    .post__actions__action__menu-reactions__icon.iconr-celebrate {
        background: #70af99;
        border-radius: 50%;
        padding: 4px;
    }

    .post__actions__action__menu-reactions__icon.iconr-red-card {
        background: #983735;
        border-radius: 50%;
        padding: 4px;
    }

    .post__actions__action__menu-reactions__icon.iconr-funny {
        background: #f3da4f;
        border-radius: 50%;
        padding: 4px;
    }

    .post__actions__action__menu-reactions__icon.iconr-sad {
        background: #f3da4f;
        border-radius: 50%;
        padding: 4px;
    } */

    .home-featured-clips-modal__comments-box {
        background: var(--white-color);
        border-radius: 10px 10px 0px 0px;
        position: absolute;
        bottom: 0;
        height: 55vh;
        width: 100%;
        z-index: 20;
    }

    .home-featured-clips-modal__comments-box__title {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 14px;
    }

    .home-featured-clips-modal__comments-box__title .baloa-table {
        color: var(--primary-very-dark-color);
        font-weight: var(--font-medium);
        margin-left: auto;
    }

    .home-featured-clips-modal__comments-box__title .icon-x {
        margin-left: auto;
        font-size: 20px;
    }

    .home-featured-clips-modal__comments-box .post__new-comment {
        position: absolute;
        bottom: 0;
        width: 100%;
    }

    .home-featured-clips-modal__comments-box .input-comments__input {
        border: 1px solid var(--new-gray-color);
        background: var(--white-color);
    }

    .home-featured-clips-modal__comments-box .post__caption {
        max-height: calc(100% - 114px);
    }
}`, "",{"version":3,"sources":["webpack://./src/app/home/components/home-featured-clips-modal/HomeFeaturedClipsModalComponent.styles.css"],"names":[],"mappings":"AAAA;GACG,oCAAoC;AACvC;;AAEA;IACI,UAAU;IACV,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,qCAAqC;IACrC,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;IACrC,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;IACV,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,8BAA8B;IAC9B,oBAAoB;AACxB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,+BAA+B;IAC/B,6BAA6B;AACjC;;AAEA;IACI,+BAA+B;IAC/B,gCAAgC;IAChC,kBAAkB;AACtB;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uCAAuC;IACvC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;AACpC;AACA;IACI,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,gCAAgC;AACpC;;AAEA,yCAAyC,4BAA4B;IACjE;QACI,WAAW;QACX,YAAY;QACZ,SAAS;QACT,gBAAgB;QAChB,iDAAiD;QACjD,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,UAAU;QACV,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,QAAQ;IACZ;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;IACA;QACI,kBAAkB;QAClB,QAAQ;QACR,QAAQ;IACZ;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,sDAAsD;QACtD,gBAAgB;QAChB,SAAS;QACT,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,UAAU;IACd;;IAEA;QACI,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,YAAY;QACZ,kBAAkB;QAClB,yBAAyB;IAC7B;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;QACzB,+BAA+B;IACnC;;IAEA;QACI,yBAAyB;QACzB,eAAe;IACnB;;IAEA;QACI,yBAAyB;QACzB,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,mBAAmB;IACvB;;IAEA;QACI,yBAAyB;QACzB,eAAe;IACnB;;IAEA;QACI,yBAAyB;QACzB,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;QACzB,eAAe;IACnB;;IAEA;QACI,yBAAyB;QACzB,eAAe;IACnB;;IAEA;QACI,iCAAiC;QACjC,UAAU;QACV,gBAAgB;QAChB,iBAAiB;QACjB,gBAAgB;QAChB,kBAAkB;QAClB,QAAQ;IACZ;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,yBAAyB;QACzB,wBAAwB;IAC5B;;IAEA;QACI,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,oDAAoD;IACxD;;IAEA;QACI,0BAA0B;QAC1B,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,6BAA6B;QAC7B,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,mBAAmB;IACvB;IACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;OA4BG;;IAEH;QACI,8BAA8B;QAC9B,gCAAgC;QAChC,kBAAkB;QAClB,SAAS;QACT,YAAY;QACZ,WAAW;QACX,WAAW;IACf;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,aAAa;IACjB;;IAEA;QACI,qCAAqC;QACrC,+BAA+B;QAC/B,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,WAAW;IACf;;IAEA;QACI,uCAAuC;QACvC,8BAA8B;IAClC;;IAEA;QACI,8BAA8B;IAClC;AACJ","sourcesContent":[".home-featured-clips-modal.modal2 {\n   background-color: rgba(0, 0, 0, 0.9);\n}\n\n.home-featured-clips-modal .modal2__container {\n    width: 90%;\n    height: 90%;\n    box-shadow: none;\n}\n\n.home-featured-clips-modal .modal2__header {\n    background: transparent;\n    color: var(--white-color);\n    border-bottom: none;\n}\n\n.home-featured-clips-modal .modal2__header__title.baloa-subtitle-2 {\n    color: var(--white-color) !important;\n    font-size: 30px;\n    font-weight: 700;\n}\n\n.home-featured-clips-modal .modal2__header__close_icon {\n    color: var(--white-color);\n    padding: 5px;\n    background: var(--primary-dark-color);\n    border-radius: 50%;\n    font-size: 40px;\n}\n\n.home-featured-clips-modal .modal2__content {\n    background: transparent;\n    padding-top: 60px;\n}\n\n.home-featured-clips-modal__container{\n    display: flex;\n    align-items: flex-start;\n    gap: 10px;\n}\n\n.home-featured-clips-modal__container .home-featured-clips-modal__media-container{\n    width: 50%;\n}\n\n.home-featured-clips-modal__post-caption {\n    padding: 12px 24px;\n}\n\n.home-featured-clips-modal__post-caption.baloa-names {\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-regular);\n}\n\n.home-featured-clips-modal__media-container {\n    border-radius: 12px;\n    background: var(--black-color);\n    height: 90vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.home-featured-clips-modal__media-container .post-profile_video_clip_post{\n    aspect-ratio: unset;\n    text-align: center;\n    max-height: 100%;\n    max-width: 100%;\n}\n\n.home-featured-clips-modal__media-container .post-profile_video_clip_post .post-profile__video_clip{\n    max-width: 100vw;\n    max-height: 90vh;\n}\n\n.home-featured-clips-modal__media-container .post-profile_video_clip_post .post-profile_video_clip_video-control{\n    height: 90%;\n}\n\n.home-featured-clips-modal__comments{\n    width: 40%;\n    background: var(--white-color);\n    border-radius: 12px;\n    height: 90vh;\n}\n\n.home-featured-clips-modal__comments .post_video_clips_actions__action{\n    margin-right: unset;\n    cursor: pointer;\n}\n\n.home-featured-clips-modal__comments .post__caption {\n    max-height: calc(90vh - 254px);\n    padding-bottom: 20px;\n}\n\n.home-featured-clips-modal__comments .post__caption.reacted {\n    max-height: calc(90vh - 312px);\n}\n\n.profile_post_new-comment__photo{\n    margin-right: var(--space-half);\n    padding: var(--space-quarter);\n}\n\n.profile_post_new-comment__photo img{\n    width: var(--space-x2-and-half);\n    height: var(--space-x2-and-half);\n    border-radius: 50%;\n}\n\n\n.profile-post-video-clip-modal__tournament-match-info{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.profile-post-video-clip-modal__tournament_info{\n    display: flex;\n    align-items: center;\n    background: var(--new-background-color);\n    padding: 2px 4px;\n    border-radius: 2px;\n}\n\n.profile-post-video-clip-modal__tournament_info .baloa-table{\n    color: var(--primary-very-dark-color);\n}\n\n.profile-post-video-clip-modal__tournament_info__img{\n    margin-right: 4px;\n}\n\n.profile-post-video-clip-modal__tournament_info__img img {\n    width: 16px;\n    height: 16px;\n    border-radius: 50%;        \n}\n\n.profile-post-video-clip-modal__tournament_info__img .icon-ball {\n    color: var(--white-color );\n    font-size: 12px;\n    border-radius: 50%;\n    padding: 2px;    \n}\n\n.home-featured-clips-modal__slide-button {\n    height: 100%;\n    display: flex;\n    align-items: center;\n    width: 5%;\n}\n\n.home-featured-clips-modal__slide-button .hubicon-arrow_circle_right{\n    font-size: 50px;\n    font-weight: var(--font-bold);\n    margin-left: auto;\n}\n\n.home-featured-clips-modal__slide-button .hubicon-arrow_circle_right .path1::before{\n    color: var(--primary-dark-color);\n}\n.home-featured-clips-modal__slide-button .hubicon-arrow_circle_left{\n    font-size: 50px;\n    font-weight: var(--font-bold);\n}\n\n.home-featured-clips-modal__slide-button .hubicon-arrow_circle_left .path1::before{\n    color: var(--primary-dark-color);\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    .home-featured-clips-modal .modal2__container{\n        width: 100%;\n        height: 100%;\n        margin: 0;\n        border-radius: 0;\n        box-shadow: 0px 1px 4px rgba(150, 150, 150, 0.25);\n        max-height: 100%;\n    }\n\n    .home-featured-clips-modal .modal2__header__title {\n        display: none;\n    }\n\n    .home-featured-clips-modal .modal2__header__close {\n        margin-left: auto;\n    }\n\n    .home-featured-clips-modal .modal2__header__close_icon {\n        font-size: 24px;\n        background: none;\n    }\n\n    .home-featured-clips-modal .modal2__content{\n        height: 100%;\n        padding: 0;\n        display: inline;\n    }\n\n    .home-featured-clips-modal__container{\n        display: block;\n        height: 100%;\n    }\n\n    .home-featured-clips-modal__slide-button {\n        width: 50px;\n        height: 50px;\n        z-index: 15;\n    }\n\n    .home-featured-clips-modal__slide-button.left {\n        position: absolute;\n        top: 50%;\n    }\n\n    .home-featured-clips-modal__slide-button .hubicon-arrow_circle_left {\n        font-size: 24px;\n        margin-left: 9px;\n    }\n    .home-featured-clips-modal__slide-button.right {\n        position: absolute;\n        top: 50%;\n        right: 0;\n    }\n\n    .home-featured-clips-modal__slide-button .hubicon-arrow_circle_right {\n        font-size: 24px;\n        margin-right: 9px;\n    }\n\n    .home-featured-clips-modal__container .home-featured-clips-modal__media-container{\n        width: 100%;\n        /* background-color: var(--primary-very-dark-color); */\n        border-radius: 0;\n        margin: 0;\n        height: 100%;\n    }\n\n    .home-featured-clips-modal__media-container .post-profile_video_clip_post {\n        width: auto;\n        height: auto;\n    }\n\n    .home-featured-clips-modal__media-container .post-profile_video_clip_post .post-profile__video_clip {\n        max-width: 100vw;\n        max-height: 100vh;\n    }\n\n    .home-featured-clips-modal__post-info {\n        position: absolute;\n        bottom: 70px;\n        left: 14px;\n    }\n\n    .home-featured-clips-modal__post-info__author {\n        display: flex;\n        align-items: center;\n    }\n\n    .home-featured-clips-modal__post-info__author-photo {\n        width: 35px;\n        height: 35px;\n        margin-right: 8px;\n    }\n\n    .home-featured-clips-modal__post-info__author-photo img{\n        width: 35px;\n        height: 35px;\n        border-radius: 50%;\n    }\n\n    .home-featured-clips-modal__post-info__author-photo .icon-ball{\n        font-size: 25px;\n        padding: 5px;\n        border-radius: 50%;\n        color: var(--white-color);\n    }\n\n    .home-featured-clips-modal__post-info__author-name .iconb2-Verificated,\n    .home-featured-clips-modal__post-info__author-name .iconbal-Balores {\n        margin-left: 6px;\n    }\n\n    .home-featured-clips-modal__post-info__author-name.baloa-table {\n        color: var(--white-color);\n        font-weight: var(--font-medium);\n    }\n\n    .home-featured-clips-modal__post-info__author-username.baloa-username {\n        color: var(--white-color);\n        margin-top: 4px;\n    }\n\n    .home-featured-clips-modal__post-info__caption.baloa-table {\n        color: var(--white-color);\n        margin-top: 12px;\n    }\n\n    .home-featured-clips-modal__post-actions {\n        position: absolute;\n        bottom: 70px;\n        right: 14px;\n    }\n\n    .home-featured-clips-modal__post-action {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        margin-bottom: 26px;\n    }\n\n    .home-featured-clips-modal__post-action .icon-claps-48 {\n        color: var(--white-color);\n        font-size: 22px;\n    }\n\n    .home-featured-clips-modal__post-action__text.baloa-mini{\n        color: var(--white-color);\n        margin-top: 5px;\n        text-align: center;\n    }\n\n    .home-featured-clips-modal__post-action .icon-message {\n        color: var(--white-color);\n        font-size: 22px;\n    }\n\n    .home-featured-clips-modal__post-action .icon-share {\n        color: var(--white-color);\n        font-size: 22px;\n    }\n\n    .home-featured-clips-modal__post-action__option {\n        box-shadow: 2px 2px 5px 2px #4444;\n        padding: 0;\n        /* width: 15%; */\n        margin-top: -50px;\n        list-style: none;\n        position: absolute;\n        right: 0;\n    }\n\n    .home-featured-clips-modal__post-action__option .post__actions__action__list__button span{\n        text-wrap: nowrap;\n    }\n\n    .home-featured-clips-modal__post-action.icon-options {\n        font-size: 22px;\n        color: var(--white-color);\n        transform: rotate(90deg);\n    }\n\n    .home-featured-clips-modal__menu-reactions .MuiList-root.MuiMenu-list {\n        display: flex;\n        align-items: center;\n    }\n\n    .MuiPopover-root.home-featured-clips-modal__menu-reactions .MuiPaper-rounded {\n        border-radius: 44px;\n        padding: 0 4px;\n    }\n\n    .home-featured-clips-modal__menu-reactions .MuiButtonBase-root.MuiMenuItem-root {\n        padding: 0 4px;\n    }\n\n    .home-featured-clips-modal__menu-reactions .post__actions__action__menu-reactions__icon:hover {\n        font-size: calc(var(--space-x3) + var(--space-half));\n    }\n\n    .home-featured-clips-modal__menu-reactions .post__actions__action__menu-reactions__icon {\n        font-size: var(--space-x3);\n        border-radius: 50%;\n    }    \n    \n    .home-featured-clips-modal__post-actions .post__actions__action__reactions__icon {\n        font-size: 22px;\n    }\n\n    .post__actions__action__reaction-green .baloa-mini {\n        color: var(--new-green-color);\n        margin-bottom: 26px;\n    }\n\n    .post__actions__action__reaction-yellow .baloa-mini {\n        color: #EECA35;\n        margin-bottom: 26px;\n    }\n\n    .post__actions__action__reaction-red .baloa-mini {\n        color: #EB3B3B;\n        margin-bottom: 26px;\n    }\n    /* .post__actions__action__menu-reactions__icon.iconr-clap {\n        background: #70af99;\n        border-radius: 50%;\n        padding: 2px;\n    }\n\n    .post__actions__action__menu-reactions__icon.iconr-celebrate {\n        background: #70af99;\n        border-radius: 50%;\n        padding: 4px;\n    }\n\n    .post__actions__action__menu-reactions__icon.iconr-red-card {\n        background: #983735;\n        border-radius: 50%;\n        padding: 4px;\n    }\n\n    .post__actions__action__menu-reactions__icon.iconr-funny {\n        background: #f3da4f;\n        border-radius: 50%;\n        padding: 4px;\n    }\n\n    .post__actions__action__menu-reactions__icon.iconr-sad {\n        background: #f3da4f;\n        border-radius: 50%;\n        padding: 4px;\n    } */\n\n    .home-featured-clips-modal__comments-box {\n        background: var(--white-color);\n        border-radius: 10px 10px 0px 0px;\n        position: absolute;\n        bottom: 0;\n        height: 55vh;\n        width: 100%;\n        z-index: 20;\n    }\n\n    .home-featured-clips-modal__comments-box__title {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        padding: 14px;\n    }\n\n    .home-featured-clips-modal__comments-box__title .baloa-table {\n        color: var(--primary-very-dark-color);\n        font-weight: var(--font-medium);\n        margin-left: auto;\n    }\n\n    .home-featured-clips-modal__comments-box__title .icon-x {\n        margin-left: auto;\n        font-size: 20px;\n    }\n\n    .home-featured-clips-modal__comments-box .post__new-comment {\n        position: absolute;\n        bottom: 0;\n        width: 100%;\n    }\n\n    .home-featured-clips-modal__comments-box .input-comments__input {\n        border: 1px solid var(--new-gray-color);\n        background: var(--white-color);\n    }\n\n    .home-featured-clips-modal__comments-box .post__caption {\n        max-height: calc(100% - 114px);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
